var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRupee(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 4.94118,
    fill: "#DEFFE6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.8725 17.6605L25.4179 19.1703H14.6262L15.0723 17.6605H25.8725ZM21.5061 31L14.7635 23.0821L14.7463 21.9755H17.6973C18.5895 21.9755 19.3501 21.8468 19.9792 21.5895C20.6083 21.3264 21.0886 20.9375 21.4203 20.4228C21.7578 19.9081 21.9265 19.2704 21.9265 18.5098C21.9265 17.3889 21.5748 16.5082 20.8713 15.8676C20.1736 15.2214 19.1728 14.8983 17.8689 14.8983H14.6262L15.0723 13.4314H17.8689C19.127 13.4314 20.1793 13.6487 21.0257 14.0833C21.8779 14.518 22.5184 15.1185 22.9473 15.8848C23.3819 16.6454 23.5993 17.5204 23.5993 18.5098C23.5993 19.4363 23.3905 20.2712 22.973 21.0147C22.5613 21.7525 21.9236 22.3386 21.06 22.7733C20.2022 23.2022 19.107 23.4167 17.7745 23.4167H17.1569L23.5049 30.8713V31H21.5061ZM25.9326 13.4314L25.4865 14.9412L16.3934 14.8983L16.8051 13.4314H25.9326Z",
    fill: "#0B952D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRupee);
export default __webpack_public_path__ + "static/media/rupee.fd498d8294cf2ccd3609d61d7aef7176.svg";
export { ForwardRef as ReactComponent };